import gql from 'graphql-tag';

export const GET_SETTING_DAYS_LIST = gql`
    query(
        $golf_group_code: String
        $date_type: Int
        $limit_rows: Int
        $begin_row: Int
    ){
    GetSettingDaysListByMaster(
        golf_group_code: $golf_group_code
        date_type: $date_type
        limit_rows: $limit_rows
        begin_row: $begin_row
    ){
        SettingDaysList{
            month_day
            date_name
            valid_flag
        }
    count
    }
  }
`;

export const UPDATE_SETTING_DAYS = gql`
  mutation(
    $month_day: String
    $date_name: String
    $golf_group_code: String
    $date_type: Int
    $old_month_day: String
    $old_date_name: String
  ){
    UpdateSettingDays(
        month_day: $month_day
        date_name: $date_name
        golf_group_code: $golf_group_code
        date_type: $date_type
        old_month_day: $old_month_day
        old_date_name: $old_date_name
  ){
    result
  }
}
`;

export const REGISTER_SETTING_DAYS = gql`
  mutation(
    $month_day: String
    $date_name: String
    $golf_group_code: String
    $date_type: Int
  ){
    RegisterSettingDays(
        month_day: $month_day
        date_name: $date_name
        golf_group_code: $golf_group_code
        date_type: $date_type
  ){
    result
  }
}
`;

export const DELETE_SETTING_DAYS = gql`
  mutation(
    $month_day: String
    $date_name: String
    $golf_group_code: String
    $date_type: Int
  ){
    DeleteSettingDays(
        month_day: $month_day
        date_name: $date_name
        golf_group_code: $golf_group_code
        date_type: $date_type
  ){
    result
  }
}
`;

export const GET_ALL_SETTING_DAYS = gql`
    query(
        $golf_group_code: String!
    ){
    GetAllSettingDays(
        golf_group_code: $golf_group_code
    ){
        AllSettingDays{
            month_day
            date_name
            date_type
        }
    }
  }
`;
